import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import MainGuidePage from "../pages/articles/MainGuidePage";
import ShoesArticlePage from "../pages/articles/ShoesArticlePage";
import HoodiesArticlePage from "../pages/articles/HoodiesArticlePage";
import TshirtsArticlePage from "../pages/articles/TshirtsArticlePage";
import JacketsArticlePage from "../pages/articles/JacketsArticlePage";
import PantsArticlePage from "../pages/articles/PantsArticlePage";
import AccessoriesArticlePage from "../pages/articles/AccessoriesArticlePage";
import BagsArticlePage from "../pages/articles/BagsArticlePage";
import SetsArticlePage from "../pages/articles/SetsArticlePage";
import JerseyArticlePage from "../pages/articles/JerseyArticlePage";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/pandabuy-spreadsheet-guide", element: <MainGuidePage /> },
  { path: "/articles/pandabuy-shoes-spreadsheet", element: <ShoesArticlePage /> },
  { path: "/articles/pandabuy-hoodies-spreadsheet", element: <HoodiesArticlePage /> },
  { path: "/articles/pandabuy-tshirts-spreadsheet", element: <TshirtsArticlePage /> },
  { path: "/articles/pandabuy-jackets-spreadsheet", element: <JacketsArticlePage /> },
  { path: "/articles/pandabuy-pants-spreadsheet", element: <PantsArticlePage /> },
  { path: "/articles/pandabuy-accessories-spreadsheet", element: <AccessoriesArticlePage /> },
  { path: "/articles/pandabuy-bags-spreadsheet", element: <BagsArticlePage /> },
  { path: "/articles/pandabuy-sets-spreadsheet", element: <SetsArticlePage /> },
  { path: "/articles/pandabuy-jersey-spreadsheet", element: <JerseyArticlePage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;